export default __webpack_public_path__ + "static/media/1v1_platinum_bg.9ec65e39.png";